var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"one-header-grid-component"},[_c('one-cms-grid-render',{attrs:{"element":_vm.header,"available-components":_vm.availableComponents}}),_vm._v(" "),_c('portal-target',{ref:"contextBar",attrs:{"name":"contextBar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }